import get from 'lodash.get';
import { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { FormattedMessage, defineMessages, useIntl } from 'dibs-react-intl';
import { updateBuyerMessage } from '../actions/checkoutUIActions';
import style from './styles/checkoutBuyerMessage.scss';
import { ExpandingArea } from 'dibs-elements/exports/ExpandingArea';
import { TextArea } from 'dibs-elements/exports/TextArea';
import ArrowDown from 'dibs-icons/exports/legacy/ArrowDown';
import classnames from 'classnames';

const messages = defineMessages({
    placeholder: {
        id: 'checkout.CheckoutBuyerMessage.placeholder',
        defaultMessage: 'Optional',
    },
});

const CheckoutBuyerMessage = ({ item, offerNotes, onUpdateBuyerMessage }) => {
    const intl = useIntl();
    const [isNotesOpen, setIsNotesOpen] = useState(true);

    const arrowStyles = classnames(style.arrow, {
        [style.arrowUp]: isNotesOpen,
    });

    function onChange(event) {
        onUpdateBuyerMessage(event.target.value);
    }
    return (
        <div className={style.wrapper}>
            <ExpandingArea
                label={
                    <span className={style.title}>
                        <FormattedMessage
                            id="checkout.CheckoutBuyerMessage.title"
                            defaultMessage="Message to {vertical, select, art {gallery} other {seller}}"
                            values={{ vertical: get(item, 'vertical') }}
                        />
                        <span className={style.arrowContainer}>
                            <ArrowDown className={arrowStyles} />
                        </span>
                    </span>
                }
                onClick={() => setIsNotesOpen(val => !val)}
                expanded={isNotesOpen}
                hideCollapsedContent
            >
                <TextArea
                    name="offerNotes"
                    value={offerNotes}
                    className={style.message}
                    placeholder={intl.formatMessage(messages.placeholder)}
                    dataTn="checkout-buyer-message"
                    onChange={onChange}
                />
            </ExpandingArea>
        </div>
    );
};

CheckoutBuyerMessage.propTypes = {
    item: PropTypes.object.isRequired,
    offerNotes: PropTypes.string,
    onUpdateBuyerMessage: PropTypes.func.isRequired,
};

const ConnecteCheckoutBuyerMessage = connect(
    ({ transaction }) => ({
        offerNotes: transaction.offerNotes,
    }),
    {
        onUpdateBuyerMessage: updateBuyerMessage,
    }
)(CheckoutBuyerMessage);

export default createFragmentContainer(ConnecteCheckoutBuyerMessage, {
    item: graphql`
        fragment CheckoutBuyerMessage_item on Item {
            vertical
        }
    `,
});
